var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPythonSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 52.16,2.02 C 34.02,2.02 29.56,9.88 29.56,22.03 L 29.56,36.56 L 53.03,36.56 L 53.03,39.91 L 20.31,39.91 C 8.16,39.91 0.31,48.06 0.31,66.22 L 0.31,85.66 C 0.31,97.81 9.06,106.12 21.22,106.12 L 35.75,106.12 L 35.75,82.66 C 35.75,69.59 46.31,59.03 59.38,59.03 L 83.69,59.03 C 95.84,59.03 103.69,50.88 103.69,32.72 L 103.69,13.28 C 103.69,1.12 94.94,2.02 82.78,2.02 L 52.16,2.02 Z M 41.62,11.38 C 44.84,11.38 47.44,13.97 47.44,17.22 C 47.44,20.44 44.84,23.06 41.62,23.06 C 38.41,23.06 35.81,20.44 35.81,17.22 C 35.81,13.97 38.41,11.38 41.62,11.38 Z",
    fill: "#306998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 57.84,107.98 C 75.98,107.98 80.44,100.12 80.44,87.97 L 80.44,73.44 L 56.97,73.44 L 56.97,70.09 L 89.69,70.09 C 101.84,70.09 109.69,61.94 109.69,43.78 L 109.69,24.34 C 109.69,12.19 100.94,3.88 88.78,3.88 L 74.25,3.88 L 74.25,27.34 C 74.25,40.41 63.69,50.97 50.62,50.97 L 26.31,50.97 C 14.16,50.97 6.31,59.12 6.31,77.28 L 6.31,96.72 C 6.31,108.88 15.06,107.98 27.22,107.98 L 57.84,107.98 Z M 68.38,98.62 C 65.16,98.62 62.56,96.03 62.56,92.78 C 62.56,89.56 65.16,86.94 68.38,86.94 C 71.59,86.94 74.19,89.56 74.19,92.78 C 74.19,96.03 71.59,98.62 68.38,98.62 Z",
    fill: "#FFD43B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPythonSvgrepoCom);
export default __webpack_public_path__ + "static/media/python-svgrepo-com.8eb96202aea3f663a07ab1158fb34057.svg";
export { ForwardRef as ReactComponent };